<template>
  <log-entry :log-entry="logEntry" :resource-type="resourceType">
    <created-properties
      :meta="meta"
      :properties="logEntry.properties"
      :relations="logEntry.relations"
      :resource-type="resourceType"
    ></created-properties>
  </log-entry>
</template>

<script>
import CreatedProperties from '@kanrisha/components/Elements/EventLog/CreatedProperties';
import LogEntry from '@kanrisha/components/AppEventLog/LogEntry';

export default {
  components: {
    CreatedProperties,
    LogEntry,
  },
  props: {
    logEntry: { type: Object, default: () => {} },
    resourceType: { type: String, default: () => '' },
    meta: { type: Object, default: () => {} },
  },
  setup() {
    return {};
  },
};
</script>
